import axios from "axios";
import { environment } from "@environments/environment";

// export async function uploadExamDetails(body: any) {
//   const token = localStorage.getItem("accessToken");
//   const apiInstance = axios.create({
//     baseURL: environment?.apiURL,
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
//   try {
//     const response = await apiInstance.post(`api/v1/exam-sessions/create`, body);
//     if (response?.data && response?.status == 201) {
//       return response?.data || {};
//     } else {
//       throw new Error("Failed to upload exam data from the API");
//     }
//   } catch (error) {
//     console.error("Error uploading exam data:", error);
//     throw new Error(
//       "Error uploading exam data: " +
//         (error instanceof Error ? error.message : String(error))
//     );
//   }
// }

export async function getUploadURL(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/question-paper/get-upload-url`,
      body
    );
    if (response && response?.status == 200) {
      return response.data?.upload_url || {};
    } else {
      throw new Error("Failed to upload file");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    throw new Error(
      "Error uploading file: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function uploadQuestionPaper(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/question-paper/create`,
      body
    );
    if (response?.data && response?.status == 201) {
      return response?.data || {};
    } else {
      throw new Error("Failed to upload question paper data");
    }
  } catch (error) {
    console.error("Error uploading question paper data:", error);
    throw new Error(
      "Error uploading question paper data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function addQuestionPaperToExam(examId: any, body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/exam/${examId}/add/question-papers`,
      body
    );
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to upload data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function createQuestionPaper(body: any) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.post(
      `api/v1/question-paper/create`,
      body
    );
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to create question paper");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function createExamSession(body:any) {
  const token=localStorage.getItem("accessToken");
  const apiInstance=axios.create({
    baseURL:environment?.apiURL,
    headers:{
      Authorization:`Bearer ${token}`,
    }
  });
  try{
    const response=await apiInstance.post(
      `api/v1/exam-sessions/create`,
      body
    );
    if(response?.data){
      return response?.data || {};
    }else{
      throw new Error("Failed to create exam session");
    }
  } catch(error){
    console.error("Error fetching data:",error);
    // throw new Error(
    //   "Error fetching data: "+
    //   (error instanceof Error ? error.message :String(error))
    // );
    throw error;
  }
}
